import React, { useContext, useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { getMeetingCode, videoCallMeeting } from '../services/merpservices';
import EmployeeContext from '../utils/EmpDetails/EmployeeProvider';
import { gaEvent } from '../utils/GoogleAnalytics/gatracking';
import { glusr_details } from '../services/userservice';
import ScheduleVideoMeet from '../components/videoMeet/ScheduleVideoMeet';

const MultiSelectCreatable = ({ glid, ak, videoMeetPopup, setShowVideoMeetTooltip }) => {
    const [showScheduleVideoMeet, setShowScheduleVideoMeet] = useState(false);
    const [meetingCode, setMeetingCode] = useState("");
    const [isLoader, setIsLoader] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [companyName, setCompanyName] = useState('');
    const employeeDetails = useContext(EmployeeContext);
    const empid = employeeDetails?.empid;
    const employee_arr = employeeDetails?.EMAIL;
    const vertical_id = employeeDetails?.FK_IIL_VERTICAL_ID;

    const hideVideMeetPopUp = () => {
        gaEvent('videoMeetSend_btn', 'videoMeetSend_btn', 'videoMeetSend_btn', `glid:${glid}`, glid);
        videoMeetPopup(); // This will hide the main video meet popup
    };

    const glusrDetails = async (ak, glid) => {
        try {
            const res = await glusr_details(ak, glid);
            if (res?.status === 200) {
                setCompanyName(res?.data['glusr_usr_companyname']);
            }
        } catch (error) {
            console.log("error");
        }
    };

    useEffect(() => {
        glusrDetails(ak, glid);
    }, [glid]);

    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const handleChange = (newValue) => {
        setSelectedOptions(newValue);
    };

    const handleCreate = (inputValue) => {
        if (isValidEmail(inputValue)) {
            const newOption = {
                label: inputValue,
                value: inputValue.toLowerCase().replace(/\W/g, ''),
            };
            setSelectedOptions([...selectedOptions, newOption]);
        } else {
            alert('Please enter a valid email address.');
        }
    };

    const currentHour = () => {
        const currentDate = new Date();
        const options = { timeZone: 'Asia/Kolkata', hour12: false };
        const ISTHour = currentDate.toLocaleString('en-US', options);
        let hour = ISTHour.split(',')[1].split(':')[0].trim();
        const minutes = ISTHour.split(',')[1].split(':')[1];
        return { hour, minutes };
    };

    const scheduleMeet = async (empid, ak, vertical_id, glid) => {
        gaEvent('videoMeetSend_btn', 'videoMeetSend_btn', 'Click', 'videoMeetSend_btn', glid);
        const currentTime = currentHour();
        const call_hour = currentTime.hour;
        const call_min = currentTime.minutes;
        let additional_array = [];
        let add_email = '';
        if (selectedOptions.length !== 0) {
            if (selectedOptions.length <= 1) {
                add_email += selectedOptions[0].label;
            } else {
                for (let i = 0; i < selectedOptions.length; i++) {
                    additional_array.push(selectedOptions[i].label);
                }
                add_email += additional_array.join(', ');
            }
        }

        const currentDate = new Date();
        const day = currentDate.getDate();
        const monthIndex = currentDate.getMonth();
        const year = currentDate.getFullYear() % 100;
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const call_date = `${day}-${months[monthIndex]}-${year}`;
        const weberp_subject = `[${companyName} (${glid})]`;

        try {
            const res = await videoCallMeeting(empid, ak, call_hour, vertical_id, call_min, employee_arr, call_date, glid, weberp_subject, add_email);
            if (res.data?.status === 200) {
                const message = res?.data?.data?.message;
                if (message === "Call updated successfully") {
                    setIsLoader(true);
                    setTimeout(async () => {
                        const meetLinkRes = await getMeetingCode(glid, empid, ak, res?.data?.data?.call_id);
                        if (meetLinkRes?.data?.status === 200) {
                            const link = meetLinkRes?.data?.data?.vedio_meet_code;
                            // setMeetingCode(`${link.slice(0, 3).toLowerCase()}-${link.slice(3, 7).toLowerCase()}-${link.slice(7).toLowerCase()}`);
                            setMeetingCode(link);
                            setShowScheduleVideoMeet(true);
                        }
                        setIsLoader(false);
                    }, 5000);
                } else {
                    setMeetingCode(`${message}.`);
                    setShowScheduleVideoMeet(true);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
        {
            <div style={{ display: 'flex', alignItems: 'center', paddingLeft:'4px' }}>
                <div style={{ width: '280px', fontSize: '16px', fontWeight:'400', lineHeight:'1.5'}}>
                    <CreatableSelect
                        isMulti
                        onChange={handleChange}
                        onCreateOption={handleCreate}
                        options={selectedOptions}
                        value={selectedOptions}
                        placeholder="Add more email-ids (optional)"
                        noOptionsMessage={() => 'Type entire email address and press enter'}
                    />
                </div>
                <button type='button' className='videomeetbtn cp' onClick={() => { scheduleMeet(empid, ak, vertical_id, glid); }}>
                    Send
                </button>
            </div>
        }
            { (isLoader || showScheduleVideoMeet) && <ScheduleVideoMeet meetCode={meetingCode} setShowScheduleVideoMeet={setShowScheduleVideoMeet} setShowVideoMeetTooltip={setShowVideoMeetTooltip} isLoader={isLoader}/> 
            }
        </>
    );
};

export default MultiSelectCreatable;

